import { clientSide } from './dom.js';

/**
 * Sets custom attributes for enabled logging services
 * @param attributes array of attributes to be set
 * @param initialize only for New Relic, if true, will not call window.newrelic.interaction().save()
 */
const logCustomAttributes = (attributes, initialize) => {
  if (clientSide && window.newrelic) {
    attributes.forEach(_ref => {
      let {
        name,
        value
      } = _ref;
      window.newrelic.setCustomAttribute(name, value);
    });
    if (!initialize) window.newrelic.interaction().save();
  }
};

/**
 * Fires error event for enabled logging services
 * @param error the error to be logged
 */
const logError = error => {
  if (clientSide && window.newrelic) {
    window.newrelic.noticeError(error);
  }
};

/**
 * Sets the current route name and saves the interaction
 * @param route the name of the route
 */
const logCurrentRoute = route => {
  if (clientSide && window.newrelic) {
    window.newrelic.setCurrentRouteName(route);
    window.newrelic.interaction().save();
  }
};

/**
 * Sets the release name and version for the enabled logging services
 * @param name of the release
 * @param id of the release
 */
const logRelease = (name, id) => {
  if (clientSide && window.newrelic) {
    window.newrelic.addRelease(name, id);
  }
};

/**
 * Fires a custom event for enabled logging services
 * @param name event name
 * @param attributes associated with the event
 */
const logEvent = function (name) {
  let attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (clientSide && window.newrelic) {
    window.newrelic.addPageAction(name, attributes);
    window.newrelic.interaction().save();
  }
};

export { logCurrentRoute, logCustomAttributes, logError, logEvent, logRelease };
